import { render, staticRenderFns } from "./GenerateWeekKeyPhysicalTargetsDialog.vue?vue&type=template&id=9d9b732c&scoped=true&"
import script from "./GenerateWeekKeyPhysicalTargetsDialog.vue?vue&type=script&lang=ts&"
export * from "./GenerateWeekKeyPhysicalTargetsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9b732c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
